export default __webpack_public_path__ + "static/media/photo--lg--73.e19717dd.jpg";